<template>
    <div class="section-box people">
        <el-tabs v-model="seaType" type="card" class="customer-tabs-mg" @tab-click="handleReset" :before-leave="tabSelect">
            <el-tab-pane 
                v-for="(item,index) in seasType"
                :label="item.value"
                :name="item.key+''"
                :key="index" 
            ></el-tab-pane>
        </el-tabs>
        <div class="customer-list">
            <div class="next-button">
                <el-button size="small" type="primary" icon="el-icon-plus" plain @click="handleShowAdd">添加</el-button>
                <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="small" type="success" @click="handleReset">重置</el-button>
            </div>
        </div>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%;margin-top: 20px;"
            height="584"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="姓名" v-if="seaType == 1">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.trueName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.trueName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="公司登录名" v-if="seaType == 2">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.loginName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.loginName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系方式">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.handset" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.handset || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属公司">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-autocomplete
                            size="mini" 
                            v-model="form.companyName" 
                            :fetch-suggestions="querySearchAsync" 
                            @select="handleSelectTest"
                            placeholder="请输入关键字搜索"
                            style="width: 100%;"
                            value-key="companyName"
                            ref="el_auto"
                            :trigger-on-focus="false"
                        >
                        </el-autocomplete>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.companyName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.jobNumber" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.jobNumber || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="deleteBindingBtn(scope.row.bindingTableId)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>



        <el-dialog 
            :title="addTitle" 
            :visible.sync="showAdd" 
            width="600px" 
            :destroy-on-close="true"
            :close-on-click-modal="false" 
        >
            <el-form label-position="left" label-width="80px"
                ref="matterAddForm" class="addPaper" >
                <el-form-item label="姓名" v-if="seaType == 1">
                    <el-autocomplete
                        v-model="addForm.trueName" 
                        :fetch-suggestions="querySearchAsyncUser" 
                        @select="handleSelectAddUserTest"
                        placeholder="请输入关键字搜索姓名"
                        style="width: 100%;"
                        value-key="trueName"
                        ref="el_auto_user"
                        clearable
                        @clear="clearSelectAuto"
                        :trigger-on-focus="false"
                    >
                        <template slot-scope="{ item }">
                            <div>
                                <span style="padding-right: 30px;min-width: 100px;display: inline-block;">姓名：{{ item.trueName }}</span>
                                <span>手机号：{{ item.handSet }}</span>
                            </div>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="手机号" v-if="seaType == 1">
                    <el-autocomplete
                        v-model="addForm.handSet" 
                        :fetch-suggestions="querySearchAsyncUser" 
                        @select="handleSelectAddUserTest"
                        placeholder="请输入关键字搜索手机号"
                        style="width: 100%;"
                        value-key="handSet"
                        ref="el_auto_user"
                        clearable
                        @clear="clearSelectAuto"
                        :trigger-on-focus="false"
                    >
                        <template slot-scope="{ item }">
                            <div>
                                <span style="padding-right: 30px;min-width: 100px;display: inline-block;">姓名：{{ item.trueName }}</span>
                                <span>手机号：{{ item.handSet }}</span>
                            </div>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="所属公司" v-if="seaType == 2">
                    <el-autocomplete
                        v-model="addForm.companyName" 
                        :fetch-suggestions="querySearchAsync" 
                        @select="handleSelectAddTest"
                        placeholder="请输入关键字搜索公司"
                        style="width: 100%;"
                        value-key="companyName"
                        ref="el_auto"
                        clearable
                        @clear="clearSelectAuto"
                        :trigger-on-focus="false"
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item label="工号">
                    <el-input v-model="addForm.jobNumber" placeholder="请输入" maxlength="100"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitBinding" :loading="addLoading">确 定</el-button>
                <el-button type="danger" @click="showAdd=false" :loading="addLoading">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {
    userBindingList,       //个人列表
    searchCompanys,        //搜搜公司
    searchUsers,           //搜索用户
    addBinding,            //提交新增数据
    companyBindingList,    //企业列表
    deleteBinding,         //删除绑定
} from "@/service/run";
import couponsIssueVue from '../coupons/couponsIssue.vue';
export default {
    data(){
        return {
            selectTab:"1",
            seasType:[{
              key: 1,
              value: "个人",
            },{
              key: 2,
              value: "企业",
            },{
              key: 3,
              value: "指标",
            }],
            form: {
                pageNum: 1,
                pageSize: 10,
                companyId: '',
                companyName: '',
                handset: '',
                jobNumber: '',  //工号
                // 个人
                trueName: '',
                // 企业
                loginName: '',
            },
            seaType: '1',
            searchData:{},
            oraginForm:{},
            total: 0,
            tableData: [],
            listLoading: false,

            showAdd: false,
            addTitle: '新增绑定',
            addLoading: false,
            addForm: {
                companyId: '',
                companyName: '',
                jobNumber: '',
                handSet: '',
                userId: '',
                trueName: '',
            }

        }
    },
    created() { 
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    activated(){
        var t= this.$route.query.t;
        console.log("t:"+t)
        this.seaType=t;
        console.log("selectTab:"+this.selectTab)
        this.handleReset();
    },
    mounted() { 
        this.handleSearch()
    },
    methods: {
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
     
        handleReset() { 
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.pageNum = val
            this.searchData.pageNum = val
            if(this.seaType == 1) {
                this.getUserBindingList()
            }else{
                // console.log('企业')
                this.getCompanyBindingList()
            }
        },
        //翻页
        handleSizeChange(val) {
            if (this.listLoading) return
            this.form.pageNum = 1
            this.form.pageSize = val
            this.searchData.pageNum = 1
            this.searchData.pageSize = val
            if(this.seaType == 1) {
                this.getUserBindingList()
            }else{
                // console.log('企业')
                this.getCompanyBindingList()
            }
        },
        // 获取列表状态
        async getUserBindingList(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            if(!data.companyId) {
                this.form.companyName = ''
            }
            !data.companyId && delete data.companyId
            !data.handset && delete data.handset
            !data.jobNumber && delete data.jobNumber
            !data.trueName && delete data.trueName
            !data.loginName && delete data.loginName
            if(data.companyName == ''){
                delete data.companyId
            }
            delete data.companyName
            data.rational = true
            let res = await userBindingList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.datas
            this.total = res.Data.total
        },

        // 搜索所属公司
        querySearchAsync(queryString,cb){
            var results = []
            if(queryString == '') {
                this.$refs.el_auto.activated = false    //隐藏下拉
                cb(results)
            }else{
                this.$refs.el_auto.activated = true     //显示下拉
                let data = {}
                data.companyName = queryString
                searchCompanys(data).then(res=> {
                    if(res.Result != 1) {
                        results = []
                        cb(results)
                    }else{
                        // var result = res.Data|| []
                        var results = res.Data || []
                        //循环放到一个远程搜索需要的数组
                        // for (let i = 0; i < result.length; i++) {
                        //     const element = result[i];
                        //     results.push({
                        //         value: element.companyName,
                        //         id: element.companyId
                        //     })
                        // }
                        cb(results);
                    }

                })
            }
        },
        handleSelectTest(item) {
            this.form.companyId = item.companyId
            this.form.companyName = item.companyName
        },
        // 搜索用户
        querySearchAsyncUser(queryString,cb) {
            var results = []
            if(queryString == '') {
                this.$refs.el_auto_user.activated = false    //隐藏下拉
                cb(results)
            }else{
                this.$refs.el_auto_user.activated = true     //显示下拉
                let data = {}
                data.handSet = this.addForm.handSet
                data.trueName = this.addForm.trueName
                searchUsers(data).then(res=> {
                    if(res.Result != 1) {
                        results = []
                        cb(results)
                    }else{
                        var results = res.Data || []
                        cb(results);
                    }

                })
            }
        },
        handleShowAdd(){
            this.showAdd = true
            if(this.seaType == 1) {
                this.addTitle = "新增绑定"
            }else {
                this.addTitle = "企业绑定"
            }
            this.addForm = {
                companyId: '',
                companyName: '',
                jobNumber: '',
                handSet: '',
                userId: '',
                trueName: '',
            }
        },
        // 新增
        handleSelectAddTest(item) {
            this.addForm.companyId = item.companyId
            this.addForm.companyName = item.companyName
        },
        handleSelectAddUserTest(item) {
            this.addForm.handSet = item.handSet
            this.addForm.userId = item.userId
            this.addForm.trueName = item.trueName
        },
        clearSelectAuto(){
            this.addForm.userId = ''
            this.addForm.handSet = ''
            this.addForm.trueName = ''
            this.addForm.companyId = ''
            this.addForm.companyName = ''
        },

        // 提交按钮
        submitBinding(){
            let data = {}
            if(this.seaType == 1) {
                if(!this.addForm.trueName && !this.addForm.userId) {
                    return this.$message.warning('姓名不能为空！')
                }
                if(!this.addForm.handSet && !this.addForm.userId) {
                    return this.$message.warning('手机号不能为空！')
                }
            }else{
                if(!this.addForm.companyName && !this.addForm.companyId) {
                    return this.$message.warning('所属企业不能为空！')
                }
            }
            if(!this.addForm.jobNumber) {
                return this.$message.warning('工号不能为空！')
            }
            data.companyId = this.addForm.companyId
            data.userId = this.addForm.userId
            data.jobNumber = this.addForm.jobNumber
            !data.companyId && delete data.companyId
            !data.userId && delete data.userId
            this.addLoading = true
            addBinding(data).then(res=>{
                this.addLoading = false
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('添加成功')
                this.showAdd = false
                this.handleSearch()
            })
        },
        
        // 获取列表状态
        async getCompanyBindingList(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            if(!data.companyId) {
                this.form.companyName = ''
            }
            !data.companyId && delete data.companyId
            !data.handset && delete data.handset
            !data.jobNumber && delete data.jobNumber
            !data.trueName && delete data.trueName
            !data.loginName && delete data.loginName
            if(data.companyName == ''){
                delete data.companyId
            }
            delete data.companyName
            data.rational = true
            let res = await companyBindingList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.datas
            this.total = res.Data.total
        },
        // 删除绑定
        deleteBindingBtn(id){
            let data = {}
            data.bindingTableId = id
            deleteBinding(data).then(res=>{
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('删除成功')
                this.handleSearch()
            })
        },
        //切换tab之前
        tabSelect(activeName, oldActiveName){
            console.log('activeName:'+activeName+";oldActiveName:"+oldActiveName);
            if(activeName=="1"||activeName=="2"){
                return true;
            }
            else{
                this.$router.push('companyTarget');
                console.log(1111);
                return false;
            } 
        }
    },
}
</script>
<style lang="scss">
    .people {
        .customer-list {
            position: relative;
            .next-button {
                position: absolute;
                right: 0;
                top: -56px;
            }
        }
    }
</style>